import type {
  CURRENT_USER_QUERY_KEY,
  CURRENT_USER_SEARCH_CONFIG_QUERY_KEY,
  CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY,
} from "./constants"

export function getCurrentUserQueryKeys({ queryKey }: { queryKey: typeof CURRENT_USER_QUERY_KEY }): unknown[] {
  return [queryKey]
}

export function getCurrentUserSearchConfigQueryKeys({
  isLogged,
  queryKey,
}: {
  isLogged: boolean
  queryKey: typeof CURRENT_USER_SEARCH_CONFIG_QUERY_KEY
}): unknown[] {
  return [queryKey, isLogged]
}

export function getCurrentUserSearchCriteriaKeys({
  isLogged,
  queryKey,
}: {
  isLogged: boolean
  queryKey: typeof CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY
}): unknown[] {
  return [queryKey, isLogged]
}
